import React from 'react'
import BarBase, { BarProps, BarType } from './BarBase'
import './BarSuccess'

function BarError(props: BarProps) {
  return (
   <BarBase {...props} type={BarType.Error} />
  )
}

export default BarError
